import classnames from "classnames";
import React from "react";
import environment from "web/script/modules/environment";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { StandardFilterProps } from "web/types/feed-filters";
import { CategoryFilterOption, InputFilterOption } from "web/types/universal-filters";
// This is only temporary disabled cause we are adding different css
// files depending on if the uj_tree_filter_all_screens flag
// is on or off.
// eslint-disable-next-line css-modules/no-unused-class
import styles1 from "./checkbox-filter-item.css";
// eslint-disable-next-line css-modules/no-unused-class
import styles2 from "./checkbox-filter-item2.css";

interface CheckboxFilterItemProps extends StandardFilterProps {
    item: InputFilterOption | CategoryFilterOption;
    isSmallItem?: boolean;
    hasChildren?: boolean;
    ariaControls?: string;
}

const CheckboxFilterItem = function CheckboxFilterItem({
    ariaControls,
    isSmallItem,
    item,
    onClick,
    pendingFilterInfo,
    hasChildren,
}): JSX.Element {
    const isCategoryHeading = item.type == "category";
    const isRadioButton = item.type == "radio";

    let treeStructure = environment.getFeature("uj_tree_filter_all_screens");
    let styles = treeStructure ? styles2 : styles1;

    function handleClick(event: React.MouseEvent<HTMLAnchorElement>): void {
        event.preventDefault();
        onClick(item);
    }

    let checked = pendingFilterInfo.getChecked(item);

    let showArrow = hasChildren;

    return (
        <a
            href={item.url}
            className={classnames(styles.filterItem, {
                [styles.selectedLabel]: checked,
                [styles.smallFilterItem]: isSmallItem,
            })}
            onClick={handleClick}
            role="button"
            aria-expanded={hasChildren ? checked : undefined}
            aria-controls={hasChildren ? ariaControls : undefined}
        >
            <div className={styles.icon}>
                {isCategoryHeading || isRadioButton ? (
                    checked ? (
                        <SVGIcon name={"round-radiobutton-checked"} />
                    ) : (
                        <SVGIcon name={"round-radiobutton"} />
                    )
                ) : checked ? (
                    <SVGIcon name={"round-checkbox-checked"} />
                ) : (
                    <SVGIcon name={"round-checkbox"} />
                )}
            </div>
            <span className={styles.labelItem}>{item.label}</span>
            {showArrow && (isCategoryHeading || isRadioButton) && (
                <SVGIcon
                    className={classnames(styles.arrow, { [styles.rotate]: checked })}
                    name="round-chevron"
                />
            )}
        </a>
    );
} as React.FC<CheckboxFilterItemProps>;

export default CheckboxFilterItem;

CheckboxFilterItem.defaultProps = {
    isSmallItem: false,
};
